import React from 'react';
import './CoursesBanner.css';
import courseImg5 from '../../../assets/Students/imagetwo.png';
import courseImg4 from '../../../assets/Students/imagethree.png';
import courseImg3 from '../../../assets/Students/imagefour.png';
import courseImg2 from '../../../assets/Students/imageFive.png';
import courseImg1 from '../../../assets/Students/imageSix.png';

function CoursesBanner() {
    const coursesBannerImages = [
        { imgSrc: courseImg1, altText: 'Course Image 1' },
        { imgSrc: courseImg2, altText: 'Course Image 2' },
        { imgSrc: courseImg3, altText: 'Course Image 3' },
        { imgSrc: courseImg4, altText: 'Course Image 4' },
        { imgSrc: courseImg5, altText: 'Course Image 5' },
    ];

    return (
        <div className='coursesbanner-outer d-flex justify-content-center align-items-center'>
            <div className="coursesbanner-inner d-flex justify-content-end align-items-start flex-column">
                <div className="coursesprofiles-outer">
                    {coursesBannerImages.map((image, index) => (
                        <div key={index} className="coursesprofiles">
                            <img src={image.imgSrc} alt={image.altText} />
                        </div>
                    ))}
                </div>
                <div className="coursesbanner-text">
                    <h1 className='header-text'>Take The Chance</h1>
                    <p className="cta-text">Do not let your dreams die in vain. Choose your <br /> courses today and enroll earliest.</p>
                </div>
            </div>
        </div>
    );
}

export default CoursesBanner;
